import { render, staticRenderFns } from "./dinamikparametre.vue?vue&type=template&id=d522b924"
import script from "./dinamikparametre.vue?vue&type=script&lang=js"
export * from "./dinamikparametre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports